// Headroom

import Headroom from 'headroom.js';
const header = document.querySelector('.header');
if (header) {
    const headroom = new Headroom(header, {
        offset: 50,
        tolerance: 5
    });
    headroom.init();
}

// Show / hide search form

const root = document.querySelector('html');
const searchButtons = document.querySelectorAll('.header__search, .deep-nav__search-button');

[...searchButtons].forEach(searchButton => {
    searchButton.addEventListener('click', function() {
        if (root.classList.contains('-search-active')) {
            root.classList.remove('-search-active');
            searchButton.setAttribute('aria-expanded', false);
        } else {
            searchButton.setAttribute('aria-expanded', true);
            root.classList.add('-search-active');
        }
    });
});
